import { render, staticRenderFns } from "./FileRow.vue?vue&type=template&id=4db22307"
import script from "./FileRow.vue?vue&type=script&lang=js"
export * from "./FileRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports